// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config$PorterinUtils from "../../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as Address$PorterinFeature from "../../../../../shared/core/domain/entities/Address.mjs";
import * as EditAddressInputCmp$PorterinFeature from "./EditAddressInputCmp.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../../../domain/store/FareEstimateStoreV1.mjs";
import * as AutocompleteDropdownStyles$PorterinFeature from "../../../../../shared/auto-complete/view/styles/AutocompleteDropdownStyles.mjs";
import * as GoogleReactAutocompleteCmpMod$PorterinFeature from "../../../../../shared/auto-complete/view/components/GoogleReactAutocompleteCmpMod.mjs";
import * as FareEstimateResultFormHelperV1$PorterinFeature from "../../../domain/helpers/FareEstimateResultFormHelperV1.mjs";
import * as EditAddressDesktopInputModuleScss from "../../styles/EditAddressDesktopInput.module.scss";

var styles = EditAddressDesktopInputModuleScss;

function EditAddressDesktopInputCmp(Props) {
  var waypoint = Props.waypoint;
  var form = Props.form;
  var address_on_change = Props.address_on_change;
  var response = Props.response;
  var error = waypoint ? FareEstimateResultFormHelperV1$PorterinFeature.getAddressFieldError(form.drop_addressResult, (function (field_errors) {
            return field_errors.drop;
          }), response, FareEstimateResultFormHelperV1$PorterinFeature.addressFieldError(Curry._1(form.dirty, undefined), waypoint, FareEstimateStoreV1$PorterinFeature.addressInputValidatorMsg)) : FareEstimateResultFormHelperV1$PorterinFeature.getAddressFieldError(form.pickup_addressResult, (function (field_errors) {
            return field_errors.pickup;
          }), response, FareEstimateResultFormHelperV1$PorterinFeature.addressFieldError(Curry._1(form.dirty, undefined), waypoint, FareEstimateStoreV1$PorterinFeature.addressInputValidatorMsg));
  return React.createElement(EditAddressInputCmp$PorterinFeature.make, {
              label: waypoint === /* Pickup */0 ? FareEstimateStoreV1$PorterinFeature.pickup_address : FareEstimateStoreV1$PorterinFeature.dropoff_address,
              is_required: true,
              is_filled: waypoint === /* Pickup */0 ? form.input.pickup_address.landmark.length === 0 : form.input.drop_address.landmark.length === 0,
              error: error,
              children: React.createElement(GoogleReactAutocompleteCmpMod$PorterinFeature.make, {
                    id: "fare-result-address-" + (
                      waypoint === /* Pickup */0 ? "pickup" : "drop"
                    ) + "",
                    value: waypoint === /* Pickup */0 ? form.input.pickup_address.landmark : form.input.drop_address.landmark,
                    api_key: Config$PorterinUtils.google_maps_api_key,
                    form_on_change: (function (address, _postal_code) {
                        Curry._1(address_on_change, address);
                      }),
                    placeholder: "",
                    wrapperStyle: AutocompleteDropdownStyles$PorterinFeature.wrapperStyle,
                    menuStyle: AutocompleteDropdownStyles$PorterinFeature.menuStyle,
                    inputClass: "" + styles["address-input"] + " " + (
                      form.submitting ? styles.disabled : ""
                    ) + "",
                    itemClass: styles["dropdown-item"]
                  }),
              waypoint: waypoint,
              clear_input: (function ($$event) {
                  if (waypoint === /* Pickup */0) {
                    return Curry._2(form.updatePickup_address, (function (input, param) {
                                  return {
                                          pickup_address: Address$PorterinFeature.initial_address(undefined),
                                          drop_address: input.drop_address,
                                          category: input.category
                                        };
                                }), $$event.target.value);
                  } else {
                    return Curry._2(form.updateDrop_address, (function (input, param) {
                                  return {
                                          pickup_address: input.pickup_address,
                                          drop_address: Address$PorterinFeature.initial_address(undefined),
                                          category: input.category
                                        };
                                }), $$event.target.value);
                  }
                })
            });
}

var make = EditAddressDesktopInputCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
